import React, { useEffect, useState } from "react";
import Tooltip from "@atlaskit/tooltip";
import { useDispatch, useSelector } from "react-redux";
import { deleteLogsForFlow } from "../../redux/actions/logActions";
import Button from "@atlaskit/button/new";
import DeleteIcon from "@atlaskit/icon/core/delete";
import ConfirmModal, {
} from "../../common/components/ConfirmModal";

const DeleteLogButton = () => {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const flow = useSelector((state) => state.integration.flow);
  useEffect(() => {}, [flow]);

  const openConfirm = () => {
    setOpen(true);
  };
  const onAction = () => {
    setOpen(false);
    dispatch(deleteLogsForFlow(flow.id))
  };

  const onClose = () => {
    setOpen(false);
  };
  return (
    <>
      <Tooltip
        content={`Delete all log entries for ${flow?.name} integration flow`}
      >
        &nbsp;&nbsp;
        <Button iconBefore={DeleteIcon} onClick={openConfirm} />
      </Tooltip>
      <ConfirmModal
        action="delete logs"
        targetName={`${flow?.name} logs`}
        targetId={flow?.id}
        isOpen={open}
        onAction={onAction}
        onClose={onClose}
      />
    </>
  );
};
export default DeleteLogButton;
